import { useEffect, useState } from "react";

const TEXT = "新盛和化工贸易内部工具";
const TILE = 320;

/**
 * Background watermark text — ported from cmd/hwgui/watermark.go.
 * Tiles the literal across the entire viewport at ~10% white, with an
 * odd-row half-tile shift to produce a brick pattern, and rotates each
 * label slightly. Pointer-events disabled so it never intercepts clicks.
 */
export function Watermark() {
  const [size, setSize] = useState({
    w: window.innerWidth,
    h: window.innerHeight,
  });
  useEffect(() => {
    const onResize = () =>
      setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const labels: { x: number; y: number }[] = [];
  let row = 0;
  for (let y = -TILE; y < size.h + TILE; y += TILE) {
    const shift = row % 2 === 1 ? TILE / 2 : 0;
    row++;
    for (let x = -TILE + shift; x < size.w + TILE; x += TILE) {
      labels.push({ x, y });
    }
  }

  return (
    <div className="watermark" aria-hidden="true">
      {labels.map((p, i) => (
        <span key={i} style={{ left: p.x, top: p.y }}>
          {TEXT}
        </span>
      ))}
    </div>
  );
}
